import {forwardRef, useEffect, useRef, useState} from "react";
import {postMessage, recvMessage} from "../../common/event";
import {Checkbox, Dropdown, MenuProps,Tooltip,message} from 'antd';
import {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1, ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG, DROPDOWN_MIN_WIDTH,
    EVENT_FAVIRIATE_CHANGE, EVENT_RESET_NO_SELECTED,
    FROM_HOME,
    FROM_RIGHT_SIDE,
    FROM_TAG,
    FROM_TRASH, KEY_PROJECT_THUMB_INDEX,
    RESPONSE_LAYOUT_L1, RESPONSE_LAYOUT_L2
} from "../../Const";
import {getBoardById, getNoteById, getNoteJsonDoc, getProjectById, updateBoard} from "../../../model";
import {findNodeWithParents, loopAllNode} from "../../TreeUtils";
import {createBoardItemMenu} from "../../MenuUtils";
import { t } from "i18next";
import {getImagePathWithThemeSvg, getIntValue, imgPathPerfix, isDarkMode} from "../../utils";
import {getDrawPath, updateFavorToFolder} from "../../Utility";
import style from './NoteItem/index.module.less'
import {onBoardItemClick} from "@/views/Library/HandleLibraryItemUtils";
import GridViewPropertyInfo from "@/views/Property/GridViewPropertyInfo";

const BoardItem = forwardRef((props:{data:any,from?:any,subFrom?:any,itemSize:any,isShowChecked?:any,searchKey?:any,tableView?:any},ref)=>{
    // const navigate = useNavigate();
    const [itemWidth,setItemWidth] = useState('0px');
    const [itemTextWidth,setItemTextWidth] = useState('0px');
    const [itemHeight,setItemHeight] = useState('140px');
    const [isShowContextMenu,setIsShowContextMenu] = useState(false);
    const [isShowMoreMenu,setIsShowMoreMenu] = useState(false);
    const [isShowMoreMenu_1,setIsShowMoreMenu_1] = useState(false);
    const [isChecked,setIsChecked] = useState(false);
    const [isHovered,setIsHoverd] = useState(false);
    const [isHoverdMore,setIsHoverdMore] = useState(false);
    const [projectStats,setProjectStats] = useState('');
    const divItemRef = useRef(null);
    const [menuItems,setMenuItems] = useState<any>([]);
    const [data,setData] = useState(props.data);

    const BORDER_RADIUS_ITEM = 8;

    useEffect(()=>{
        recvMessage(EVENT_FAVIRIATE_CHANGE,(msg,data)=>{
            // setMenuItems(createMenu());
        })

        resizeWindow();

        const resizeObserver = new ResizeObserver(entries => {
            resizeWindow();
        })
        if (divItemRef.current){
            resizeObserver.observe(divItemRef.current);
        }

        window.addEventListener("resize",resizeWindow)
        return()=>{
            window.removeEventListener('resize',resizeWindow);
        }
    },[]);

    useEffect(() => {
        if (props.data){
            //这里统计画板和卡片数量
            const newData = {...data};
            getNoteById(newData.projectId,true,true).then(res=>{
                if (res){
                    newData.projectName = res.name || t('Untitled');
                    const node = findNodeWithParents(res.doc.canvas,newData.id);
                    if (node){
                        newData.parentNodes = node.parents;
                    }
                    if (!data.thumbUrl){
                        newData.thumbUrl = res.thumbUrl;
                    }
                    setData(newData);
                }
            })
        }
    }, [props.data]);

    useEffect(() => {
        if (props.itemSize){
            setItemWidth(props.itemSize.width+'px');
            setItemHeight(props.itemSize.height+'px');
        }
    }, [props.itemSize]);

    useEffect(() => {
        setIsChecked(props.data.isChecked);
    });

    function resizeWindow(){
        if (props.from == FROM_RIGHT_SIDE)return;

        const margin = 11;
        let nItemCount = 4;
        if (props.from == FROM_TAG || props.from == FROM_TRASH){
            nItemCount = 5;
        }else if (props.from == FROM_HOME){
            let nDocumentWidth = document.body.clientWidth;
            if (nDocumentWidth < RESPONSE_LAYOUT_L1){
                nItemCount = 4;
            }else if (nDocumentWidth < RESPONSE_LAYOUT_L2){
                nItemCount = 5;
            }else{
                nItemCount = 6;
            }
        }

        // var item = document.getElementById("#divList");
        //左边菜单240 -- 间距margin左右各20  每个item的间距 8
        let nWidth = divItemRef.current?.clientWidth;//(document.body.clientWidth-241-(nItemCount-1)*(32) - 32)/nItemCount - 4;
        let nHeight = nWidth*9/16;
        if (props.from == FROM_TAG || props.from == FROM_TRASH){
            // const nWidth = (document.body.clientWidth-241-(5)*(8*2) - 30)/nItemCount;
            // nHeight = nWidth*0.76;
        }else if (props.from == FROM_HOME){
            // let nItemWidth = divItemRef?.current?.clientWidth;
            // console.log(nWidth)
            nHeight = nWidth *0.68 ;
        }
        nHeight = nWidth *0.68 ;

        setItemTextWidth((nWidth - 16)+'px');
        setItemWidth(nWidth+'px');
        setItemHeight(nHeight+'px');
    }

    /**
     * 转到编辑
     */
    const navNoteEdit = async ()=>{
        if (data.isDeleted === 1) return;
        postMessage(EVENT_RESET_NO_SELECTED);
        window.navigateOrigin(getDrawPath(),{state:{searchKey:props.searchKey,linkInfo:{id:data.projectId,pageId:data.id}}});

    }

    const isCustomImage = (data)=>{
        if (data.thumbUrl){
            if (data.thumbUrl.startsWith('localfile://')){
                return true;
            }
            return false;
        }
        return true;
    }

    const getImageSrc = (data)=>{
        if (data.thumbUrl){
            if (data.thumbUrl.startsWith('localfile://')){
                return data.thumbUrl;
            }
            //旧的全部换成新的.
            let nOldIndex = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_1.findIndex(p=>data.thumbUrl.includes(p));
            if (nOldIndex != -1){
                if (nOldIndex >= ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length){
                    nOldIndex = 0;
                }
                data.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nOldIndex];
            }
            return imgPathPerfix()+(isDarkMode()?data.thumbUrl.replace('.png','_white.png'):data.thumbUrl);
        }else{
            // let nIndex:any = getIntValue(localStorage.getItem(KEY_PROJECT_THUMB_INDEX), 0);
            // if (nIndex < 0 || nIndex > ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length) {
            //     nIndex = 0;
            // }
            // data.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[nIndex];
            // localStorage.setItem(KEY_PROJECT_THUMB_INDEX, (nIndex+1) % ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.length + '');
            // updateBoard(data);
        }
        return data.thumbUrl;
    }

    /**
     * 主是要菜单favor的点击...有二级菜单的情况下，一级是不响应的.
     */
    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = function (event:any){
                        //这里是添加到根
                        handleMenuClick({key:'favor'});
                        setIsShowContextMenu(false);
                        setIsShowMoreMenu(false);
                        setIsShowMoreMenu_1(false);
                    }
                }
            }
        },100)
    }

    const handleMenuClick = async (e: any) => {
        onBoardItemClick(e.key,data,(szAction)=>{
            if ('ok' == szAction){
                window.globalRefreshList('refresh_tag_item_list_')
            }
        });
    }

    /**
     * 取名称
     */
    const getName = ()=>{
        let szTitle = data.projectName + '/';
        if (data.parentNodes){
            szTitle += data.parentNodes.map(p=>{
                return p.title + '/';
            }).join('')
        }
        return szTitle + data.name;
    }

    /**
     * 重置菜单---
     */
    const resetMenuItems = ()=>{
        setMenuItems(createBoardItemMenu(props.data,async (key:any)=>{
            if (data.isFavirated == 1){
                data.isFavirated = 0;
            }else{
                data.isFavirated = 1;
            }
            data.favirateTime = new Date().getTime();
            //把这个data插入到文件夹下...
            await updateFavorToFolder(key,data);

            updateBoard(data).then(res=>{
                postMessage(EVENT_FAVIRIATE_CHANGE);
            })
        }));
    }


    const renderGridView =()=> {
        return (
            // style={{width:itemWidth,height:itemHeight}}
            <Dropdown overlayClassName='default-dropdown-style' open={isShowContextMenu}
                      overlayStyle={{minWidth:`${DROPDOWN_MIN_WIDTH}px`}}
                      menu={{ items:menuItems ,onClick: handleMenuClick}} trigger={['contextMenu']}
                      onOpenChange={async (e)=>{
                          if (e){
                              resetMenuItems()
                              patchMenuFavor();
                          }
                          setIsShowContextMenu(e);
                      }}>
                <div ref={divItemRef} data-id={props.data?.id} className={style.NoteStyle + ' carditem hovered-some-image'} style={{
                    margin: props.from == FROM_TAG?'8px':'0px 0px',
                    height:props.from == FROM_TAG?'calc(100% - 16px)':'auto',
                    display: "flex",
                    flexDirection: 'column',
                    position:'relative',
                    // borderRadius:'12px',
                    overflow:'hidden',
                    cursor:'pointer',
                    width:'auto',//props.subFrom == FROM_RIGHT_SIDE?itemWidth:'auto',
                    visibility: props.data.id === '-1' ? 'hidden' : 'visible'}} onMouseEnter={()=>{
                    setIsHoverd(true)
                }} onMouseLeave={()=>{
                    setIsHoverd(false);
                }}>
                    <div className={style.imgView} onClick={async () => {
                        if (props.from == FROM_TAG) {
                            if (props.isShowChecked) {
                                props.data.isChecked = !isChecked;
                                setIsChecked(!isChecked)
                            }else {
                                navNoteEdit();
                            }
                        }else {
                            navNoteEdit();
                        }
                    }} style={{
                        height: itemHeight,
                        // backgroundColor:'var(--home-item-background-color-new)',//#F1F1F1
                        // borderRadius: '8px',
                        overflow:'hidden',
                        position:'relative',
                        flexShrink:'0'
                        // border: props.data.isChecked?'1px solid var(--link-color)':'0px solid var(--border-color)',
                    }}>

                        <div className={' flex-column-center'} style={{zIndex:'12',height: itemHeight,
                            overflow:'hidden',borderRadius:`${BORDER_RADIUS_ITEM+1}px`,margin:'0px',padding:isCustomImage(data)?'0px':'0px',}}>
                            <img src={getImageSrc(data)} alt=""
                                 style={{width: props.data.id == 'newProject'?'16px':'100%', height: props.data.id == 'newProject'?'16px':'100%', objectFit: isCustomImage(data)?'cover':'contain',borderRadius:'8px',overflow:'hidden'}}/>
                            {
                                props.data.id == 'newProject' &&
                                <span className={'default-font-size'} style={{marginTop:'8px',color:'var(--text-color-66666)'}}>{t("New project")}</span>
                            }
                        </div>

                        {
                            props.data.id != 'newProject' &&
                            <div style={{position: "absolute", top: '8px', right: '8px',visibility:isHovered?'visible':'hidden'}}
                                 onMouseEnter={()=>setIsHoverdMore(true)} onMouseLeave={()=>setIsHoverdMore(false)}
                                 onClick={(event) => {
                                     event.stopPropagation();
                                     setIsShowContextMenu(false);
                                 }}>
                                {
                                    (props.from !== FROM_TRASH) &&
                                    <Tooltip arrow={false} title={t("Change thumbnail")}>
                                        <img className={'img-24'} src={getImagePathWithThemeSvg('home_item_change_thumb')} onClick={()=>{
                                            window.showDialogChooseThumb(data,(newData)=>{
                                                window.globalRefreshList('refresh_tag_item_list_');
                                            });
                                        }}/>
                                    </Tooltip>
                                }

                                {
                                    (props.from !== FROM_TRASH) &&
                                    <Tooltip arrow={false} title={t("Info")}>
                                        <img className={'img-24 ml-8'} src={getImagePathWithThemeSvg('library_info')} onClick={()=>{
                                            getBoardById(data.id).then(res=>{
                                                window.showInfo('project',res);
                                            })
                                        }}/>
                                    </Tooltip>
                                }

                                <Dropdown trigger={['click']} open={isShowMoreMenu_1} overlayStyle={{minWidth:`${DROPDOWN_MIN_WIDTH}px`}} onOpenChange={(e)=>{
                                    //要改菜单的地方太多了。DYAMIC
                                    resetMenuItems();
                                    setIsShowMoreMenu_1(e);
                                    patchMenuFavor();
                                }} menu={{items: menuItems, onClick: handleMenuClick}}>
                                    <Tooltip arrow={false} title={t("More")}>
                                        <img className={'img-24 ml-8'} src={getImagePathWithThemeSvg((isHoverdMore?'library_more':"library_more"))}/>
                                    </Tooltip>
                                </Dropdown>
                            </div>
                        }

                        {
                            //下半部分的标题和项目信息统计
                            (props.from !== FROM_TAG && props.from !== FROM_TRASH && props.subFrom != FROM_RIGHT_SIDE) &&
                            <div style={{position:'absolute',bottom:'0',overflow:'hidden',
                                background:'var(--home-item-project-info-background-color)',width:'100%',minHeight:'52px',
                                padding:'0 12px',
                                display:'flex',
                                flexDirection:'column',
                                justifyContent:'center',
                                borderTop:'1px solid var(--line-color)',borderRadius:`0 0 ${BORDER_RADIUS_ITEM}px ${BORDER_RADIUS_ITEM}px`}}>
                    <span className='span-single-line font-size-12 default-font-family font-family-medium' style={{
                        width: props.subFrom == FROM_RIGHT_SIDE ? 'auto' : itemTextWidth,
                    }}>{getName()}</span>
                                <span　className={'mt-2'} style={{fontSize:'10px',color:'var(--color-666666)'}}>{projectStats}</span>
                            </div>
                        }
                    </div>


                    {
                        props.subFrom == FROM_RIGHT_SIDE && props.data.id !== 'newProject' &&
                        <span className={'flex-center span-single-line'} style={{
                            position: 'absolute',
                            bottom: '0px',
                            fontSize: '13px',
                            height: '30px',
                            width: 'calc(100% - 1px)',
                            lineHeight: '30px',
                            color: 'white',
                            padding: '0 12px',
                            display: 'block',
                            overflow: 'hidden',
                            left:'1px',
                            borderRadius:'0 0 8px 8px',
                            background: 'rgba(0,0,0,.55)'
                        }}>{data.name}</span>
                    }

                    {
                        props.isShowChecked &&
                        <>
                            <Checkbox checked={isChecked} style={{position: "absolute", right: '12px', top: '6px', zIndex: '99'}}
                                      onClick={(event) => {
                                          setIsChecked(!isChecked);
                                          props.data.isChecked = !isChecked;
                                          // props.onCheckedCallback(props.data);
                                      }}/>
                        </>
                    }

                    {
                        (props.from == FROM_TRASH || (props.tableView && props.tableView.columns.length == 0)) &&
                        <span className={'flex-center span-single-line'} style={{
                            position: 'absolute', bottom: '0px',
                            borderRadius:'0 0px 8px 8px',
                            right:'0px',
                            height: '30px', background: 'rgba(0,0,0,.66)', width: '100%', lineHeight: '30px',
                            color: 'white', padding: '0 12px', display: 'block', overflow: 'hidden'
                        }}>{getName()}</span>
                    }

                    {
                        props.tableView && props.tableView.columns.length > 0 &&<>
                            <div className={'line'} style={{width:'100%'}}></div>
                            <GridViewPropertyInfo tableView={props.tableView} item={props.data}/>
                        </>
                    }

                    <div className={'hovered-home-border'} style={{position:'absolute',
                        top:'0',left:'0',width:'100%',height:'100%',
                        pointerEvents:'none',
                        border:(isHovered || props.data.isChecked)?'1.3px solid var(--primary-color)':'1.3px solid var(--line-color)'}}>

                    </div>
                </div>
            </Dropdown>
        )
    }

    return renderGridView();
})


export default BoardItem;